//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SidebarHeader from '@/components/SidebarHeader'
import SearchResult from '@/components/SearchResult'
import { date } from 'quasar'
export default {
  name: 'Sidebar',

  components: {
    SidebarHeader,
    SearchResult
  },

  computed: {
    records() {
      return this.$store.state.sidebarRecords || []
    }
  },

  methods: {
    date(d) {
      return date.formatDate(d, "ddd Do MMMM 'YY") // e.g. "Wed 1st July '20"
    },

    statusColor(status) {
      if (status.toUpperCase() === 'SENT') {
        return 'green'
      }
      if (status.toUpperCase() === 'APPROVAL REQUIRED') {
        return 'red'
      }
    },

    getUserName(record) {
      try {
        return `${record.external.atmos.user.name.first} ${record.external.atmos.user.name.last}`
      } catch (e) {
        return `${record.user.name.first} ${record.user.name.last}`
      }
    }
  }
}
